import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Store from '../store/index.js'

Vue.use(VueI18n)

export default new VueI18n({
  locale: Store.getters.selectedLanguage.key,
  fallbackLocale: 'ja',
  silentFallbackWarn: true,
  messages: window.i18nmessage,
})
